import Game from "../../Game";
import BaseSlider from "../..//entities/BaseSlider";
import { RootEventBus, EnumRootEventBus } from "../../managers/RootEventBus";
import { Coord, SliderGenProps } from "../../types/Interface";
import { generateSliderProps, getSliderCoords } from "./helpers/sliderHelpers";


export default class BaseSliderManager {
  Game = Game.getInstance();
  RootEventBus = RootEventBus;
  EnumRootEventBus = EnumRootEventBus;
  sliders: BaseSlider[] = [];
  slidersProps: SliderGenProps[] = [];
  dim = this.Game.getDim();

  constructor(slidersProps: SliderGenProps[], SLIDERS_COORD: Coord[], SLIDERS_COORD_OFFSET_VERTICAL: Coord[]) {
    this.slidersProps = slidersProps;
    this.generateSliders(SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);

    this.RootEventBus.on(EnumRootEventBus.completedIntroAnim, () => this.setAllVisible(true));
  }

  getSliders = () => this.sliders;
  setAllVisible = (v: boolean) => this.sliders.forEach(slider => slider.visible = v);
  handleEnd = () => {
    this.RootEventBus.emit(EnumRootEventBus.setRefRadians);
    setTimeout(() => this.sliders.forEach(s => s.Slider.value = 100), 100);
  };
  generateSliders(SLIDERS_COORD, SLIDERS_COORD_VERTICAL) {
    const coords = getSliderCoords(this.dim, SLIDERS_COORD, SLIDERS_COORD_VERTICAL);
    coords.forEach((coord, cI) => {
      const sProps = this.slidersProps[cI]
      const slider = this.addSlider(coord, sProps, sProps.onUpdate);
      this.sliders.push(slider)
    })
  }
  addSlider(coord: Coord, sGProps: SliderGenProps, onUpdate: (v: number) => void) {
    const props = generateSliderProps(coord, sGProps.head, sGProps.colors, sGProps.subHead);
    return new BaseSlider(props, this.handleEnd, onUpdate);
  }
}